<template>
  <div id="solo_game">
    <game-navbar v-if="header" :currentScore="gameProgress.currentScore"></game-navbar>
    <div class="game_container">
      <game-header
        v-if="header"
        :gameInfo="gameInfo"
        :premium="chosenBets.win"
        :attempts="[gameProgress.previousAttempts]"
      ></game-header>
      <div
        class="category_info"
        :class="{'categoryOpen' : showCategory}"
        :style="{
          color: '#fff',
          background: colors.theme == 'dark' ? colors[colors.theme].from : '#a5a5a5'
          
        }"
      >
        <strong>{{$t("views.main.category_info")}}</strong>
        <span>{{enigmaCategory}}</span>
      </div>
      <div class="solo_game_container" :class="{'categoryOpen' : showCategory}"
        :style="{
          'background':`linear-gradient(180deg, ${colors[colors.theme].to} 0%,  ${colors[colors.theme].from} 100%)`
        }">
        <div class="options wrapper"> 
          <div class="options_content wrapper">
            <div class="buy_hint" @click="buyTips">
              <BuyHint></BuyHint>
              <div class="buy_hint_info"
              :style="{
                  color: colors.theme == 'dark' ? `#fff` : `#000`
                }">
                <span>{{$t("views.main.buy_hint_info.span1")}}</span>
                <span>{{$t("views.main.buy_hint_info.span2")}}</span>
              </div>
            </div>
            <div class="surrender" @click="surrenderModal()">
              <div class="surrender_info">
                <p>
                  {{$t("views.main.surrender_info.span1")}}
                </p>
                  <p>{{$t("views.main.surrender_info.span2")}}</p>
              </div>
              <Giveup></Giveup>
            </div>
          </div>
        </div>
  
        <div class="wrapper hints">
          <game-loader
            v-show="!hintsLoaded"
            class="centeredLoader"
            loaderStyle="circle"
            :textColor="colors.theme == 'dark' ? '#fff' : '#000'"
            :loaderMessage="$t('views.main.wrapper_hints.loaderMessage')"
          ></game-loader>
          <div class="hint" v-show="hintsLoaded">
            <span class="hidden"></span>
            <carousel
              :per-page="1"
              :navigateTo="gameProgress.askedHints.length"
              :mouse-drag="true"
              :paginationEnabled="false"
              :navigationEnabled="true"
            >
              <slide v-for="(current, index) in gameProgress.askedHints" :key="current.id">
                <span class="hint_index"
                  :style='{ color : colors.theme == "dark" ? colors.primary : "#000"}'
                >{{$t("views.main.wrapper_hints.hint_index")}} {{index + 1}}</span>
                <p class="hint_desc"
                  :style='{ color : colors.theme == "dark" ? "#fff" : "#636362"}'
                >{{current}}</p>
              </slide>
            </carousel>
          </div>
        </div>
        <div id="answer">
          <div class="answer">
        <input
          :style="{
            'background':`linear-gradient(90deg, ${colors.secondary} 0%,  ${colors.secondary} 100%)`,
            color: buttonDisabled ? '#000' : '#fff',
            fontWeight: buttonDisabled ? '500' : '800'
          }"
          id="input"
          autocomplete="off"
          :class="{active: gameProgress.attempt}"
          :placeholder="$t('views.main.answer_input.input')"
          type="text"
          @input="gameProgress.attempt = $event.target.value"
          @keyup.enter="trigger"
              />
        <button
          :style="{background: buttonDisabled ? '#d4deef' : '#fff' }"
          class="answer_button"
          ref="sendAttempt"
          v-show="!sendingAttempt"
          @click="sendAttempt"
          :disabled="buttonDisabled">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="100px" height="100px"
              viewBox="0 -10 45 200" xml:space="preserve">
              <polygon 
                :fill="buttonDisabled ? 'rgb(188, 199, 206)' : colors.primary" 
                points="5.08,3.61 25.08,32.25 5.08,60.88 45.29,32.25 "/>
            </svg>
            <!-- <span v-show="!sendingAttempt"></span> -->
              </button>
        <game-loader class="loader-attempt" v-show="sendingAttempt" :circleColor="colors.primary" loaderStyle="bullets"></game-loader>
            <!-- <div class="answer_input">
              <input
                :style="{background: `${colors.buttons.primary}80`}"
                id="input"
                autocomplete="off"
                :class="{active: gameProgress.attempt}"
                placeholder="Insira sua resposta aqui"
                type="text"
                @input="gameProgress.attempt = $event.target.value"
                @keyup.enter="trigger"
              />
              <button
                :style="{background: buttonDisabled ? '#bcc7ce' : colors.buttons.primary}"
                class="answer_button"
                ref="sendAttempt"
                @click="sendAttempt"
                :disabled="buttonDisabled"
              >
                <span v-show="!sendingAttempt">Enviar</span>
                <game-loader v-show="sendingAttempt" loaderStyle="bullets"></game-loader>
              </button>
            </div>-->
          </div>
          <div
            class="attempts wrapper"
            v-show="gameProgress.previousAttempts.length > 0"
            :style="{background: colors.theme == 'dark' ? '#000' : '#fff'}"
          >
            <div class="attempts_content">
              <div class="arrow arrow_left">
                <img src="/img/icons/arrow-hint-navigation-left.png" alt=" anterior" />
              </div>
              <div class="attempts_count" ref="attempts_count">
                <div
                :style="{color: colors.theme == 'dark' ? '#fff' : '#000'}"
                  class="wrong_attempt"
                  ref="wrong_attempt"
                  v-for="wrongAttempts of gameProgress.previousAttempts"
                  :key="wrongAttempts.id"
                >
                  <img src="/img/icons/wrong-icon.png" alt="Tentativas incorretas" />
                  <span>{{wrongAttempts}}</span>
                </div>
              </div>
              <div class="arrow arrow_right">
                <img src="/img/icons/arrow-hint-navigation-right.png" alt=" anterior" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal-options
      :showModal="modalOptionsData.show"
      v-on:hideModal="hiddingModal($event)"
      :colorTheme="colors.theme"
      :modalTitle="modalOptionsData.modalTitle"
      :modalSubtitle="modalOptionsData.modalSubtitle"
      :multiple="modalOptionsData.multiple"
      :surrending="modalOptionsData.surrending"
      :surrender="modalOptionsData.surrender"
      :titleBtnOk="modalOptionsData.titleBtnOk"
      :titleBtnCancel="modalOptionsData.titleBtnCancel"
    ></modal-options>

    <feedback-attempt :showFeedback="feedback.showFeedback" :attempt="feedback.attempt" :colorTheme="colors.theme"></feedback-attempt>
  </div>
</template>

<script>
import Navbar from "./../components/shared/header/Navbar";
import Header from "./../components/shared/header/Header";
import Loader from "./../components/shared/default/Loader";
import FeedbackAttempt from "./../components/shared/default/FeedbackAttempt";
import ModalWithOptions from "./../components/shared/default/ModalWithOptions";
import BuyHint from "./../components/shared/customIcons/BuyHint";
import Giveup from "./../components/shared/customIcons/Giveup";
import { Bus } from "../event-bus.js";
// import HintsOptions from '../components/shared/game/HintsOptions';
// import Hints from '../components/shared/game/Hints';
// import Answer from '../components/shared/game/Answer';
import { Carousel, Slide } from "vue-carousel";

export default {
  name: "Main",

  components: {
    "game-navbar": Navbar,
    "game-header": Header,
    "game-loader": Loader,
    "modal-options": ModalWithOptions,
    "feedback-attempt": FeedbackAttempt,
    BuyHint,
    Giveup,
    // "game-hints-options": HintsOptions,
    // "game-hints": Hints,
    // "game-answer": Answer,

    Carousel,
    Slide
  },

  data: function() {
    return {
      hintsLoaded: false,
      sendingAttempt: false,
      urlGame: `${process.env.VUE_APP_HOST_FUNCTIONS_REPENSE}`,

      gameInfo: null,
      enigmaCategory: "",
      showCategory: true,
      last: [],

      gameProgress: {
        index: 0,
        askedHints: [],
        previousAttempts: [],
        currentAttemptNumber: 1,
        attempt: ""
      },

      chosenBets: {
        answer: "",
        bet: "",
        win: ""
      },

      // Data do ANSWER
      playerExtract: {
        attemptCount: "",
        HintsUsed: ""
      },
      status: "inprogress",

      modalOptionsData: {
        show: false,
        surrending: false,
        surrender: false,
        currentEnigma: null,
        hideModal: "",
        modalTitle: "",
        multiple: true,
        titleBtnOk: this.$t("views.main.modalOptionsData.titleBtnOk"),
        titleBtnCancel: this.$t("views.main.modalOptionsData.titleBtnCancel"),
        last_id: "",
        modalSubtitle: this.$t("views.main.modalOptionsData.modalSubtitle")
      },
      header: true,

      feedback: {
        showFeedback: false,
        attempt: ""
      },
      colors: {}
    };
  },
//   mounted() {
//     let self = this;
//     window.addEventListener("focus", function() {
//       self.header = true;
//     });
//     window.addEventListener("blur", function() {
//       self.header = false;
//     });
//   },
  beforeRouteLeave(to, from, next) {
    if (from.name == "Solo game" && this.status == "inprogress") {
      next(false);
    }

    if (this.status != "inprogress") {
      let soloGameId = localStorage.getItem("soloGameId");
      if (!this.status == "timeout") {
        this.$http
          .patch(
            `${process.env.VUE_APP_HOST_FUNCTIONS_REPENSE}/solo-games/timeout?soloGameId=${soloGameId}`
          )
          .then(response => {
            //TODO: make a warning message showing up instead console.log
            // console.log("timeout");
          });
      }
      next(true);
    }
  },

  async created() {
    this.colors = JSON.parse(localStorage.getItem("colors"));
    // console.log("TEMA: ", this.colors.theme)
    localStorage.setItem("initializeGame", true);
    Bus.$on("timeout", this.timeout);
    Bus.$on("modalEvent", this.surrender);
    Bus.$on("alterStatus", this.alterStatus);
    let bet = this.$store.getters.getBet;
    if (bet) {
      await this.$store.commit("subScoreState", bet);
    }

    let self = this;
    let secondsDiff = localStorage.getItem("secondsDiff");
    let soloGameId = localStorage.getItem("soloGameId");
    // console.log("soloGameId: ", soloGameId);
    if (secondsDiff < -600) {
      this.$http
        .patch(
          `${process.env.VUE_APP_HOST_FUNCTIONS_REPENSE}/solo-games/timeout?soloGameId=${soloGameId}`
        )
        .then(response => {
          localStorage.setItem("secondsDiff", "");
          self.$store.commit("setTimeDiscount", -300);
          self.status = "timeout";
          self.$router.push("/");
        });
    }
    if (this.$store.getters.getSoloGame.length == 0) {
      let gameSetId = localStorage.getItem("gameSetId");
      this.$http
        .get(
          `${process.env.VUE_APP_HOST_FUNCTIONS_REPENSE}/solo-games/game-set-games?gameSetId=${gameSetId}`
        )
        .then(response => {
          // console.log(response);
          self.$store.commit("setSoloGameRequest", response.body.soloGames);
          self.startSoloGameRequest();
        });
    } else {
      this.startSoloGameRequest();
    }
  },
  destroyed() {
    Bus.$off("timeout");
    Bus.$off("modalEvent");
    Bus.$off("alterStatus");
  },
  methods: {
    alterStatus(status) {
      this.status = status;
    },
    async timeout() {
      localStorage.removeItem("initializeGame");
      Bus.$on("endClock", true);
      let self = this;
      let soloGame = localStorage.getItem("lastSoloID");
      self.status = "timeout";
      let objectTimeout = {};
      objectTimeout.attemptCount = self.gameProgress.previousAttempts;
      objectTimeout.hintsUsed = self.gameProgress.askedHints.length - 1;
      objectTimeout.answer = self.gameProgress.attempt;
      objectTimeout.status = "timeout";
      self.$store.commit("addExtractState", objectTimeout);
      // console.log("Antes do Try");
      try {
        let timeoutReq = await this.$http.patch(
          `${process.env.VUE_APP_HOST_FUNCTIONS_REPENSE}/solo-games/timeout?soloGameId=${soloGame}`,
          {},
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        );
        self.$store.commit("setTimeDiscount", -300);
        // console.log("Dentro do Try");

        // console.log("Timeout REQ:", timeoutReq.body);
        self.$router.push({
          name: "Extract",
          params: {
            statusExtract: "timeout",
            correct: true
          }
        });
      } catch (er) {
        //TODO: make a error message showing up instead console.log error
        // console.log("Erro no timeout: ", er);
      }
      // console.log("Depois do Try");
    },
    startSoloGameRequest() {
      this.gameInfo = this.$store.getters.getSoloGame;
      localStorage.setItem("SoloGameSize", this.gamesInfo.length);
      this.last = this.defineLastSolo(this.gameInfo);
      this.enigmaCategory = this.last.enigma.category;
      let lastBet = this.last.bet;
      // console.log(this.last.bet);
      this.chosenBets.bet = lastBet;
      this.chosenBets.win = lastBet * 2;
      let initSoloGame = this.gameInfo[0].createdAt;
      let requestedHints = "";
      if (this.last.attempts) {
        this.gameProgress.previousAttempts = this.last.attempts.map(attempt => {
          return attempt.attempt;
        });
      }
      if (this.last.requestedHints) {
        requestedHints = this.last.requestedHints.length;

        let hints = this.last.enigma.hints.filter((enigma, index) => {
          return index <= requestedHints ? enigma[index] : "";
        });
        this.gameProgress.askedHints = hints;
      } else {
        this.gameProgress.askedHints.push(this.last.enigma.hints[0]);
      }
      this.hintsLoaded = true;

      setTimeout(() => {
        this.showCategory = false;
      }, 3000);
    },
    showFeedbackAttempt(isCorrect, qtAttempt) {
      setTimeout(() => {
        this.feedback.showFeedback = false;
        this.feedback.attempt = "_";
      }, 1500);
      if (isCorrect) {
        this.feedback.attempt = "correct";
        this.feedback.showFeedback = true;

        setTimeout(() => {
          this.viewExtract(true, "correta");
        }, 1500);
        return;
      }
      if (qtAttempt > 3) {
        this.feedback.attempt = "wrong_discount";
        this.feedback.showFeedback = true;
        // console.log(this.feedback.attempt);
        // console.log(qtAttempt);
        // console.log("if 2");
        return;
      }
      this.feedback.attempt = "wrong";
      this.feedback.showFeedback = true;
      // console.log(this.feedback.attempt);
      // console.log(qtAttempt);
      // console.log("if 3");
    },
    async buyTips() {
      this.hintsLoaded = false; //Econde a opção de ver a pista anterior
      if (this.gameProgress.askedHints.length < 10) {
        let newTip = await this.$http.get(
          this.urlGame + `/solo-games/request-hint?soloGameId=${this.last.id}`,
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        );
        this.hintsLoaded = true;
        this.gameProgress.askedHints.push(newTip.body);
        this.gameProgress.index = this.gameProgress.askedHints.length - 1;
        this.$store.dispatch("subScore", 500);
        localStorage.setItem(
          "localScore",
          localStorage.getItem("localScore") - 500
        );
      } else {
        this.$swal({
          type: "error",
          title: this.$t("views.main.limit_hint_info.title"),
          text: this.$t("views.main.limit_hint_info.text")
        });
        this.hintsLoaded = true;
      }
    },
    hiddingModal(hide) {
      this.modalOptionsData.show = false;
    },
    surrenderModal() {
      this.modalOptionsData.modalTitle =
        // "Desistir do enigma " + this.gameInfo.length + "/4?";
        this.$t("views.main.surrenderModal")  + this.gameInfo.length + "/4?";
      this.modalOptionsData.show = true;
      this.modalOptionsData.surrender = true;
      this.modalOptionsData.currentEnigma = this.gameInfo.length;
    },
    async surrender() {
      try {
        localStorage.removeItem("initializeGame");
        Bus.$emit("endClock", true);
        this.status = "giveup";
        this.modalOptionsData.surrending = true;
        let surenderReq = await this.$http.patch(
          this.urlGame + `/solo-games/giveup?soloGameId=${this.last.id}`,
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        );
        // console.log(this.modalOptionsData.surrending);
        localStorage.setItem("soloGameId", this.last.id);
        this.viewExtract(true, "desistente");
        let objectSurrender = {};
        objectSurrender.attemptCount = this.gameProgress.previousAttempts;
        objectSurrender.hintsUsed = this.gameProgress.askedHints.length - 1;
        objectSurrender.answer = "";
        objectSurrender.status = "correct";
        this.$store.dispatch("addExtract", objectSurrender);
      } catch (error) {
        this.modalOptionsData.surrending = false;
        //TODO: make a error message showing up instead console.log error
        // console.log("Erro ao desistir do : ", error);
      }
    },
    verifyEqualAttempt(attemptSend) {
      let attempts = this.gameProgress.previousAttempts;
      let equal = attempts.some(attempt => {
        return attempt == attemptSend;
      });

      return equal;
    },
    // ANSWER METHODS
    async sendAttempt() {
      let attemptValue = this.gameProgress.attempt;
      // Tira os espaços da resposta para verificação

      var attemptFormatted = attemptValue.toLowerCase();
      attemptFormatted = attemptFormatted.replace(
        new RegExp("[ÁÀÂÃ]", "gi"),
        "a"
      );
      attemptFormatted = attemptFormatted.replace(
        new RegExp("[ÉÈÊ]", "gi"),
        "e"
      );
      attemptFormatted = attemptFormatted.replace(
        new RegExp("[ÍÌÎ]", "gi"),
        "i"
      );
      attemptFormatted = attemptFormatted.replace(
        new RegExp("[ÓÒÔÕ]", "gi"),
        "o"
      );
      attemptFormatted = attemptFormatted.replace(
        new RegExp("[ÚÙÛ]", "gi"),
        "u"
      );
      attemptFormatted = attemptFormatted.replace(new RegExp("[Ç]", "gi"), "c");
      attemptFormatted = attemptFormatted.replace(/\s/g, "");

      //Verificar se o campo está em branco
      if (attemptValue == "") {
        alert("Campo de resposta está vazio");
        return;
      }

      let equalAtempt = await this.verifyEqualAttempt(attemptFormatted);
      if (equalAtempt) {
        input.value = "";
        this.scrollHorizontal();
        return;
      }

      //verifica se a resposta digitada está dentro do array de possibilidades aceitas
      // let correctAnswer = this..answers.some(answer =>  answer == attemptFormatted)
      try {
        this.sendingAttempt = true;
        this.gameProgress.attempt = ""; //Limpa o input de respos
        let attemptReq = await this.$http.post(
          this.urlGame + "/solo-games/attempt",
          {
            soloGameId: this.last.id,
            attempt: attemptValue
          },
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        );

        // console.log(attemptReq.body);
        var { correct, qtAttempts } = attemptReq.body;
      } catch (error) {
        //TODO: make a error message showing up instead console.log error
        // console.log("Erro ao enviar a tentativa: ", error);
      }

      this.sendingAttempt = false; //remove o loader

      //Retorno ao usuário sobre a resposta enviada
      //Se a tentativa estiver correta, captura quantas pistas o jogador pediu e quantas tentativas utilizou
      await this.gameProgress.previousAttempts.push(attemptValue);
      if (this.gameProgress.previousAttempts.length > 3) {
        this.$store.dispatch("subScore", 50);
        //    localStorage.setItem('localScore', localStorage.getItem('localScore') - 50)
      }

      // console.log("Attempt: ", attemptValue);
      //Caso a tentativa esteja errada, adiciona ela no array
      if (correct) {
        await this.showFeedbackAttempt(correct, qtAttempts);
        localStorage.removeItem("initializeGame");
        Bus.$emit("endClock", true);
        this.status = "correct";
        Bus.$emit("endClock", true);
        this.playerExtract.attemptCount = this.gameProgress.previousAttempts;
        this.playerExtract.hintsUsed = this.gameProgress.askedHints.length - 1;
        this.playerExtract.answer = attemptValue;
        this.playerExtract.status = "correct";

        // this.current = this.current + 1
        this.gameProgress.currentAttemptNumber = 1;
        this.gameProgress.previousAttempts = [];
        this.$store.dispatch("sumScore", this.chosenBets.win); // função vuex para somar score
        // this.get(true)

        localStorage.setItem("soloGameId", this.last.id);
        // localStorage.setItem('',JSON.stringify(this.))
        localStorage.setItem(
          "player_extract",
          JSON.stringify(this.playerExtract)
        );
        this.$store.dispatch("addExtract", this.playerExtract);

        // this.viewExtract(true, 'correta')
        this.feedback.correct = "correct";
        return;
      }
      this.showFeedbackAttempt(correct, qtAttempts);
      // console.log("qtAttempts:", qtAttempts);
      this.currentAttemptNumber++;
      input.value = "";
      this.scrollHorizontal();
    },
    viewExtract(correct, statusExtract) {
      this.$router.push({
        name: "Extract",
        params: {
          statusExtract,
          correct
        }
      });
    },
    trigger() {
      this.$refs.sendAttempt.click();
    },
    defineLastSolo(soloGames) {
      if (soloGames.length < 2) return soloGames[0];
      let lastSolo = soloGames.reduce((a, b) => {
        return a.createdAt > b.createdAt ? a : b;
      });
      return lastSolo;
    },
    scrollHorizontal() {
      this.$refs.attempts_count.scrollTo(
        this.$refs.attempts_count.scrollWidth,
        0
      );
    }
  },

  computed: {
    buttonDisabled() {
      return this.gameProgress.attempt.length == 0 ? true : false;
    },
    gamesInfo() {
      return this.$store.getters.getSoloGame;
    }
  }
};
</script>

<style lang="scss">
// CSS Main Component
#solo_game {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: hidden;
  .game_container{
    height: calc(100% - 55px);
    // padding-top: 55px;
    display:flex;
    flex-direction: column;
    overflow: hidden;
  }
  .category_info {
    // display: flex;
    // justify-content: center;
    text-transform: uppercase;
    letter-spacing: 3px;
    text-align: center;
    font-size: 11px;
    // background-color: #3f7cac38;
    // color: #3f7cac;
    padding: 8px 0;
    min-height: 1vh;
    transition: min-height 1s, font-size 1s, padding 1s;

    strong {
      font-weight: 900;
    }
    span {
      font-weight: 600;
    }
  }
  .category_info.categoryOpen {
    min-height: 80vh;
    font-size: 33px;
    // justify-content: center;
    // align-items: center;
    // flex-direction: column;
    padding: 70% 0;
  }
}

.solo_game_container.categoryOpen {
  opacity: 0;
}

.solo_game_container {
  width: 100%;
  //height: 81vh;
  height: 100%;
  display: flex;
  flex-direction: column;
  //justify-content: space-between;
  transition: opacity 1s;

  .options {
    //height: 15%;
    //min-height: 68px;
    padding-top: 5px;

    .options_content {
      height: 100%;
      padding: 0;
    }
  }

  .hints {
    //height: 60%;
    height: calc(100% - 136px);
    display: flex;
    align-items: center;
    justify-content: center;

    .hint {
      .hint_desc {
        font-size: 18px;
      }
    }
  }
}

#answer {
  //height: 20%;
  //min-height: 140px;
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding-bottom:10px;

  .attempts {
    //height: 30%;
  }

  .answer {
  width: 100%;
  display: flex;
  justify-content: center;
    margin-bottom: 32px;

      input {
        display: flex;
        width: 80%;
        height: 40px;
        border: none;
        border-radius: 150px;
        padding: 15px 32px;
        font-size: 21px;

        &::placeholder{
          color: #fff;
        }
      }

      .answer_button {
    position: relative;
    right: 75px;
    border-radius: 150px;
    border-bottom-color: rgba(0,0,0,.3);
    width: 45px;
    height: 45px;
    border-left: none;
    border-top: none;
    border-right: none;
    display: flex;
      align-self: center;
      }
  .loader-attempt{
    position: relative;
    right: 75px;
    display: flex;
    align-self: center;
  }
  }
}

.options_content {
  padding: 32px 0 0 0;
}

.options_content,
.buy_hint,
.surrender {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.options_content {
  .buy_hint_info{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }
  .surrender_info {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
  }
  .buy_hint {
    svg {
      width: 45px;
      height: 45px;
    }
    &:hover {
      cursor: pointer;
    }
    .buy_hint_info {
      text-transform: uppercase;
      & span:nth-child(1) {
        font-size: 20px;
        letter-spacing: 1px;
        font-weight: 900;
        padding: 0 0 3px 0;
      }
      & span:nth-child(2) {
        font-weight: 600;
        font-size: 17px;
      }
    }
  }
  .surrender {
    svg {
      width: 45px;
      height: 45px;
      &:hover {
        cursor: pointer;
      }
    }
    .surrender_info {
      text-transform: uppercase;
      color: #ff0047;

      p ,span{
        font-size: 23px;
        letter-spacing: 1px;
        font-weight: 900;
        padding: 0 10px 3px 0;
        display: flex;
        flex-direction: column;
        text-align: right;

        span {
          font-size: 15px;
          padding: 2px 5px 0 0;
        }
      }
    }
  }
}

// Final do CSS do HintsOptions
.hints {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  //height: 50vh;
  align-items: center;

  .arrow {
    display: flex;
    align-items: center;

    img {
      max-width: 55%;
    }
  }

  .hint {
    text-align: center;
    max-width: 85%;
    margin: auto;

    .hidden {
      visibility: hidden;
    }

    .VueCarousel {
      flex-basis: 100%;

      .VueCarousel-navigation {
        .VueCarousel-navigation-button {
          background-position: center !important;
          background-size: contain !important;
          color: transparent;
          width: 25px;
          height: 25px;
        }

        .VueCarousel-navigation-next {
          background: url(../../public/img/icons/arrow-hint-navigation-right.png) no-repeat;
        }
        .VueCarousel-navigation-prev {
          background: url(../../public/img/icons/arrow-hint-navigation-left.png) no-repeat;
        }
      }

      .VueCarousel-slide {
        flex-basis: 100%;
        margin-bottom: 10%;
      }
    }

    .hint_desc {
      margin: 15px;
      color: #000;
      font-weight: 700;
      font-size: 26px;
    }
    .hint_index {
      font-size: 22px;
      letter-spacing: 1px;
      // color: #939393;
      font-weight: 900;
    }
  }
}

//Media Screen Header

@media screen and (max-width: 1366px) {
  .hints {
    //height: 33vh;
  }
}
@media screen and (max-width: 550px) {
  .options_content {
    padding: 15px 0 0 0;

    .buy_hint {
      justify-content: flex-start;
      padding: 0 0 0 5px;

      .buy_hint_info {
        padding: 0 0 0 10px;

        & span:nth-child(1) {
          font-size: 15px;
        }
        & span:nth-child(2) {
          font-size: 12px;
        }
      }

      img {
        max-width: 45px;
      }
    }
    .surrender {
      justify-content: flex-end;

      .surrender_info {
        p {
          font-size: 15px;

          span {
            font-size: 8px;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 400px) {
	.hints {
		//height: 55vh;
  	}

	.solo_game_container{
		#answer{
			.answer{
				.answer_button{
					right: 35px;
				}
				input{
					height: 45px;
					width: 70% !important;
				}
			}
		}
	}
}
@media screen and (max-width: 355px) {
  .options_content {
    .buy_hint {
      .buy_hint_info {
        & span:nth-child(1) {
          font-size: 9px;
        }
        & span:nth-child(2) {
          font-size: 9px;
        }
      }

      svg {
        max-width: 25px;
      }
    }
    .surrender {
      justify-content: flex-end;

      img {
        max-width: 25px;
      }

      .surrender_info {
        p {
          font-size: 9px;

          span {
            font-size: 7px;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 321px) {
  #answer {
    // position: relative;
    .answer_input {
      input {
        width: 93%;
      }
    }
  }
  .hints .hint .hint_desc {
    margin: 10px 7px !important;
    font-size: 15px !important;
  }
  .hints .hint .hint_index {
    font-size: 17px !important;
  }
}

// Inicio do CSS do ANSWER

#answer {
  // height: 100vh;
  // display: flex;
  // flex-direction: column;
  // justify-content: space-between;
  position: fixed;
  width: 900px;
  bottom: 0;

  .container {
    margin: 0;
  }
}
.attempts {
  .attempts_content {
    display: flex;
    align-items: center;
    height: 100%;
    padding: 0;

    .arrow {
      width: 10%;

      img {
        max-width: 20%;
      }
    }
    .arrow_right {
      text-align: right;
    }
  }
  .attempts_count {
    display: flex;
    width: 100%;
    height: 90%;
    overflow-y: hidden;
    overflow-x: overlay;
    // flex-direction: row-reverse;

    .wrong_attempt {
      align-items: center;
      font-size: 17px;
      padding: 2px 10px;
      display: flex;
      white-space: nowrap;

      img {
        max-width: 13px;
        padding: 0 10px 0 0;
      }
    }
  }
}
.answer {
  .answer_input {
    input {
      height: 45px;
      font-size: 24px;
      text-align: center;
      font-weight: 200;
      border: none;
      // background-color: rgba($color: #fff581, $alpha: 1);
    }
    .active {
      background-color: #ffffcc;
    }
  }
  .answer_button {

    &:hover {
      cursor: pointer;
    }
    &:disabled {
      &:hover {
        cursor: not-allowed;
      }
      color: #f4f4f4;
      background-color: #bcc7ce;
    }
  }
}

//iPad Plus
@media screen and (max-width: 900px) {
  #answer {
    // position: absolute;
    width: 100vw !important;
    bottom: 0;
  }
}

@media screen and (min-width: 700px) {
  .hint_index {
    font-size: 28px !important;
  }

  .hint_desc {
    font-size: 28px !important;
  }
  #solo_game {
    .category_info {
      font-size: 18px;
    }
    .buy_hint {
      svg {
        width: 50px;
        height: 50px;
        padding-right: 15px;
      }
    }
    .surrender {
      svg {
        width: 50px;
        height: 50px;
        padding-left: 15px;
      }
    }
  }
}
@media screen and (min-width: 750px) {
  .solo_game_container{
    height: 86vh;
  }

}

@media screen and (max-width: 700px) {
	.solo_game_container {

		#answer {
		  .answer_button {
			// height: 60px;
			font-size: 22px;
      right: 45px !important;
		  }
	  
		  .answer {
			input {
			  	width: 80%;
			  	font-size: 17px;
				// height: 20px;
			}
			.answer_button,.loader-attempt {
			  position: absolute;
			}
		  }
		}
	}
}

@media screen and (max-width: 400px) {
  #answer {
    // position: absolute !important;
    // width: 100vw !important;
    // bottom: 0;

    .attempts {
      .attempts_content {
        .surrender {
          .surrender_info {
            p {
              span {
                padding: 3px 5px 0 0;
              }
            }
          }
        }

        .wrong_attempt {
          font-size: 15px;
        }
      }
    }
  }
}

@media screen and (max-width: 321px) {
  #answer {
    position: relative;
  }
  .hints .hint .hint_desc {
    margin: 10px 7px !important;
    font-size: 15px !important;
  }
  .hints .hint .hint_index {
    font-size: 17px !important;
  }
}
</style>
